import { useState } from "react"
import Separator from "@/v2-ui/separator"
import type { TableSelectionToolbarProps } from "@/v2-backoffice-client/components/table"
import Table from "@/v2-backoffice-client/components/table"
import { TooltipButton } from "@/v2-backoffice-client/components/button"
import TenantUserAddManySelectorDialog from "@/v2-backoffice-client/tenant/user/add/many/TenantUserAddManySelectorDialog"
import UserStatusUpdateManyToolbar from "@/v2-backoffice-client/user/status/update/many/UserStatusUpdateManyToolbar"
import UserContactSyncManyButton from "@/v2-backoffice-client/user/contact/sync/many/UserContactSyncManyButton"
import UserMigrateManyButton from "@/v2-backoffice-client/user/migration/many/UserMigrateManyButton"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"

export type UserTableSelectionToolbarProps = Omit<
  TableSelectionToolbarProps<UserFragment>,
  "children"
> & {
  users: UserFragment[]
  reset?(): void
}

function UserTableSelectionToolbar(props: UserTableSelectionToolbarProps) {
  const { users, reset } = props

  const [tenantDialogOpen, setTenantDialogOpen] = useState(false)
  const userIds = users.map((u) => u.Id)

  return (
    <>
      <Table.ExportSelectionButton
        fileName="users"
        selectionCount={users.length}
      />

      <TooltipButton
        isStacked
        variant="ghost"
        iconSrc="users"
        content="Add the selected users to a team."
        onClick={() => {
          setTenantDialogOpen(true)
        }}
      >
        Set Tenant
      </TooltipButton>

      <UserContactSyncManyButton users={users} onCompleted={reset} />

      <UserMigrateManyButton users={users} onCompleted={reset} />

      <Separator orientation="vertical" />
      <UserStatusUpdateManyToolbar users={users} onCompleted={reset} />

      <TenantUserAddManySelectorDialog
        open={tenantDialogOpen}
        onOpenChange={setTenantDialogOpen}
        userIds={userIds}
        onCompleted={reset}
      />
    </>
  )
}

export default UserTableSelectionToolbar
